export default __webpack_public_path__ + "static/media/Controle.a4f6ffeb.svg";